import { ACCREDITATIONS, COMPANY, yearsTrading } from '../../lib/company';

/**
 * The "who we are" block on the public login page, rendered over the dark hero.
 *
 * This is the only description of the business that anyone can read without
 * signing in, so it carries the things that establish Jones + Palmer as a real
 * and long-established company: where we are, how long we have traded, what we
 * do, and the certifications a reviewer can independently check.
 */
export function AboutJp() {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 18, maxWidth: 520 }}>
      <p className="mono" style={{ opacity: 0.6, margin: 0 }}>
        jones+palmer · birmingham · since {COMPANY.foundedYear}
      </p>

      <div
        style={{
          fontSize: 46,
          fontWeight: 700,
          lineHeight: 1.04,
          letterSpacing: '-0.02em',
          textWrap: 'balance',
        }}
      >
        When clarity really matters.
      </div>

      <p
        style={{
          margin: 0,
          fontSize: 14.5,
          lineHeight: 1.6,
          color: 'rgba(255,255,255,.74)',
        }}
      >
        {COMPANY.name} is a strategic corporate communications agency in Birmingham&rsquo;s
        Jewellery Quarter, trading for over {yearsTrading()} years. We work with listed and
        regulated organisations on reporting, investor communications and stakeholder engagement
        &mdash; and we build the tools behind this sign-in to do it.
      </p>

      <ul
        style={{
          display: 'flex',
          flexWrap: 'wrap',
          gap: 7,
          listStyle: 'none',
          margin: 0,
          padding: 0,
        }}
      >
        {ACCREDITATIONS.map((item) => (
          <li
            key={item}
            className="mono"
            style={{
              border: '1px solid rgba(255,255,255,.22)',
              borderRadius: 3,
              padding: '4px 9px',
              color: 'rgba(255,255,255,.72)',
            }}
          >
            {item}
          </li>
        ))}
      </ul>

      <p style={{ margin: 0, fontSize: 13, color: 'rgba(255,255,255,.56)' }}>
        <a
          href={COMPANY.url}
          target="_blank"
          rel="noopener noreferrer"
          style={{ color: 'rgba(255,255,255,.82)', textUnderlineOffset: 3 }}
        >
          jonesandpalmer.co.uk
        </a>{' '}
        &middot;{' '}
        <a
          href={COMPANY.contactUrl}
          target="_blank"
          rel="noopener noreferrer"
          style={{ color: 'rgba(255,255,255,.82)', textUnderlineOffset: 3 }}
        >
          Contact us
        </a>{' '}
        &middot;{' '}
        <a
          href={COMPANY.phoneHref}
          style={{ color: 'rgba(255,255,255,.82)', textUnderlineOffset: 3 }}
        >
          {COMPANY.phone}
        </a>
      </p>
    </div>
  );
}
